import React, { useState, useEffect } from 'react';
import './chatWidget.css';
import ChatComponent from './ChatComponent';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import key from '../../key';
import { Link } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';


function ChatWidget() {
    const [showChat, setShowChat] = useState(-1);
    const navigate = useNavigate();
    const chatsInitiated = useSelector((state) => state.user.user.chatsInitiated);
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    const [chatData, setChatData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortFlag, setSortFlag] = useState(false);


    useEffect(() => {
        const fetchUserData = async (userId) => {
            try {
                const result = await axios(`${key}/api/user/get-profile/${userId}`, {
                    headers: {
                        "x-auth-token": cookies['x-auth-token'],
                    },
                });
                await axios.put(`${key}/api/user/read-message`, { userId: userId }, {
                    headers: {
                        "x-auth-token": cookies['x-auth-token'],
                    }
                });
                return result.data.user; // Return the user data from the function
            } catch (error) {
                console.log(error.message);
            }
        };

        const fetchChatData = async (chatArray) => {
            try {
                const userPromises = chatArray.map(async (chat) => {
                    const userData = await fetchUserData(chat.userId);
                    return {
                        name: userData.firstName + ' ' + userData.lastName,
                        image: `${key}/images/${userData?.photos[0]?.url}`,
                        userId: userData.userId,
                        id: userData._id,
                        latestMessageDate: null,
                        latestMessageContent: null,
                        unreadMessages: null,
                    };
                });

                const chatData = await Promise.all(userPromises);
                setChatData(chatData);
                setLoading(false);
            } catch (error) {
                console.log(error.message);
            }
        };

        fetchChatData(chatsInitiated);
        //eslint-disable-next-line
    }, [chatsInitiated, cookies['x-auth-token']]);



    const formatFirebaseTimestamp = (timestamp) => {
        try {
            const currentDate = new Date();
            const messageDate = timestamp.toDate();

            const currentYear = currentDate.getFullYear();
            const messageYear = messageDate.getFullYear();

            const currentDay = currentDate.getDate();
            const messageDay = messageDate.getDate();

            const messageTime = messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

            let formattedTimestamp = '';

            if (currentYear !== messageYear) {
                formattedTimestamp = messageYear;
            }

            if (currentDay !== messageDay) {
                formattedTimestamp += ` ${messageDate.toLocaleDateString([], { month: 'short', day: 'numeric' })}`;
            }

            formattedTimestamp += ` ${messageTime}`;

            return formattedTimestamp.trim();
        } catch (error) {
            console.log(error.message);
        }
        return '';
    };


    const handleOpenChat = (userId) => {
        setShowChat(userId);
    };



    const updateUnreadMessages = (index, latestMessageDate, latestMessageContent, unreadMessages) => {
        setChatData((prevChatData) => {
            const updatedChatData = [...prevChatData];
            updatedChatData[index] = {
                ...updatedChatData[index],
                latestMessageDate: latestMessageDate,
                latestMessageContent: latestMessageContent,
                unreadMessages: unreadMessages,
            };

            if (!sortFlag) {
                setSortFlag(true);
                updatedChatData.sort((a, b) => { return b.latestMessageDate - a.latestMessageDate });
            }
            else {
                updatedChatData.unshift(updatedChatData.splice(index, 1)[0]);
            }
            return updatedChatData;




        });
    };

    useEffect(() => {
        //eslint-disable-next-line
    }, [chatData]);


    if (loading) {
        return (
            <div className='container chat-page-container text-center'>
                <div className="loading-spinner"><PulseLoader size={50} color="#fa585b" /></div>
            </div>
        )
    }

    if (chatsInitiated.length === 0) {
        return (
            <div className='container chat-page-container text-center'>
                <h5 className="pageHeading">You need to connect with Members first</h5>
                <Link to="/newmatches" className="text-decoration-none">
                    <button className="fw-bold w-25 mx-auto primary-btn p-2 my-3" style={{ cursor: "pointer", borderRadius: 6, color: "white" }}>
                        Find Matches
                    </button>
                </Link>
            </div>
        )
    }

    return (

        <div className='container chat-page-container'>

            <div className='row'>
                <div className='col col-sm-12 col-md-3 col-lg-3'>
                    <div className=' container chat-widget-container'>
                        {chatData?.map((item, index) => {
                            return (
                                <div key={item.userId}>
                                    <li className='notification-item chat-item' onClick={() => handleOpenChat(item.userId)}>
                                        <div className='d-flex'>
                                            <div onClick={()=>navigate(`/view-profile/${item?.id}`)}>
                                                <img className='notification-img' src={item?.image} alt="profile" />
                                            </div>
                                            <div>
                                                <div>
                                                    <h6>{item?.name} </h6>
                                                    {item?.latestMessageDate &&
                                                        <p className='latest-message'>{formatFirebaseTimestamp(item?.latestMessageDate)} <br /> {((item?.latestMessageContent?.length > 30) ? (item?.latestMessageContent?.slice(0, 30) + ' ...') : item?.latestMessageContent)}</p>
                                                    }
                                                </div>
                                                <div className={`${item.unreadMessages ? "unread-messages" : ""}`}>{item.unreadMessages ? item.unreadMessages : null}</div>
                                            </div>
                                        </div>
                                        <ChatComponent
                                            key={item.userId}
                                            item={item}
                                            showChat={showChat}
                                            setShowChat={setShowChat}
                                            i={index}
                                            id={item.id}
                                            updateUnreadMessages={updateUnreadMessages}
                                        />
                                    </li>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChatWidget;
